import { useEffect, useMemo, useState } from "react";

import { useLiveClassroomListCount } from "@transfr-inc/dashboard-sockets";

import { Role } from "@models/role";
import { useCurrentUser, useRole, useMissionControlEnabled } from "@queries";

const socketUrl = process.env.SOCKET_BRIDGE_URL;

export function useMissionControlLiveCount(orgCode) {
  const [missionControlLiveCount, setMissionControlLiveCount] = useState({});
  const currentUser = useCurrentUser();
  const missionControlEnabled = useMissionControlEnabled();
  const role = useRole();
  const { organizationCode, token } = currentUser || {};
  let organizationLiveCount = {};

  const missionControlOrgCode = useMemo(() => {
    return role === Role.MULTI_ORG_ADMIN.id || role === Role.MULTI_ORG_VIEWER.id
      ? orgCode
      : organizationCode;
  }, [orgCode, organizationCode]);

  if (missionControlEnabled) {
    organizationLiveCount = useLiveClassroomListCount(
      socketUrl,
      token,
      missionControlOrgCode
    );
  }

  useEffect(() => {
    // Validate that the live count has really changed to avoid unnecessary re-renders
    // that raise a warning in the consol for exceding the max number of re-renders
    const organizationKeys = Object.keys(organizationLiveCount);
    const missionControlKeys = Object.keys(missionControlLiveCount);

    // Check if the keys are the same
    const hasSameKeys =
      organizationKeys.length === missionControlKeys.length &&
      organizationKeys.every((key) => missionControlKeys.includes(key));

    // Check if the values are the same
    const hasSameValues = organizationKeys.every(
      (key) => organizationLiveCount[key] === missionControlLiveCount[key]
    );

    if (!hasSameKeys || !hasSameValues) {
      setMissionControlLiveCount(organizationLiveCount);
    }
  }, [organizationLiveCount]);

  return missionControlLiveCount;
}
